import { render } from "./jobBack.vue?vue&type=template&id=86ad9da6&scoped=true"
import script from "./jobBack.vue?vue&type=script&lang=js"
export * from "./jobBack.vue?vue&type=script&lang=js"

import "./jobBack.vue?vue&type=style&index=0&id=86ad9da6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ad9da6"]])

export default __exports__